import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Link } from 'react-router-dom';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: IconDefinition;
  link: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, description, icon, link }) => {
  return (
    <div className="bg-white rounded-lg shadow-card p-8 card-hover group">
      <div className="flex flex-col items-center text-center">
        <div className="h-20 w-20 bg-secondary rounded-full flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
          <FontAwesomeIcon icon={icon} className="h-10 w-10 text-accent group-hover:text-white transition-colors duration-300" />
        </div>
        <h3 className="text-2xl font-semibold mb-4 text-accent">{title}</h3>
        <p className="text-gray-600 mb-6">{description}</p>
        <Link 
          to={link} 
          className="text-primary border-b-2 border-primary pb-1 font-medium hover:text-accent hover:border-accent transition-colors duration-300 inline-flex items-center"
        >
          En savoir plus
          <svg className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard; 